import { m } from "framer-motion";
import { PILLARS } from "@/content/marketing";

/** Home — share / files itself / publish, the product in three cards. */
export default function PillarCards() {
  return (
    <section className="px-6 pb-[70px] md:px-8">
      <div className="mx-auto grid max-w-6xl gap-4 md:grid-cols-3">
        {PILLARS.map((pillar, index) => (
          <m.div
            key={pillar.index}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.35 }}
            transition={{ duration: 0.45, delay: index * 0.06 }}
            className="rounded-[18px] border border-white/[0.07] bg-[#0F0F11] p-[26px]"
          >
            <p className={`ios-chip-label ${pillar.accent}`}>
              {pillar.index} &middot; {pillar.kicker}
            </p>
            <h3 className="mt-2.5 text-xl font-bold text-ios">{pillar.title}</h3>
            <p className="mt-[7px] text-sm leading-normal text-ios-secondary">{pillar.body}</p>
          </m.div>
        ))}
      </div>
    </section>
  );
}
